import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const Step1 = () => {
  const { t } = useTranslation()

  const { register } = useFormContext()

  return (
    <div className="flex flex-col gap-y-6">
      <p className="text-sm text-navy-900 font-semibold">{t('event.step1')}</p>

      <div className="flex flex-col gap-y-4">
        <label className="flex gap-x-2 items-center">
          <input
            type="radio"
            className="w-4 h-4"
            {...register('options', { required: true })}
            value={t('event.withdraw')}
          />
          <span className="text-navy-900 text-sm">{t('event.withdraw')}</span>
        </label>
        <label className="flex gap-x-2 items-center">
          <input
            type="radio"
            className="w-4 h-4"
            {...register('options', { required: true })}
            value={t('event.withdrawAndRefund')}
          />
          <span className="text-navy-900 text-sm">{t('event.withdrawAndRefund')}</span>
        </label>
        <label className="flex gap-x-2 items-center">
          <input
            type="radio"
            className="w-4 h-4"
            {...register('options', { required: true })}
            value={t('event.refundOnly')}
          />
          <span className="text-navy-900 text-sm">{t('event.refundOnly')}</span>
        </label>
      </div>
    </div>
  )
}
